import { put } from "@redux-saga/core/effects";

import { FieldsService } from "./../../../services/fields";

import { addBulkOptionsSuccess } from "./../actionCreaters";
import { optionsResponse, SwitchOptionsActionType } from "./../types";

export function* switchOptionsSaga({ payload: { fieldId, newOptions } }: SwitchOptionsActionType) {
    try {
        yield FieldsService.deleteBulkOptions(fieldId);

        const {
            data: { data },
        }: optionsResponse = yield FieldsService.addBulkOptions(fieldId, newOptions);

        yield put(addBulkOptionsSuccess({ fieldId, options: data.options }));
    } catch (error) {
        // yield put(Handle Error);
    }
}
